const selectFirstWord = (e: React.FocusEvent<HTMLInputElement>) => {
  setTimeout(() => {
    if (e.target.value !== 'Untitled Dataset') return;
    const el = e.target;
    const value = el.value ?? '';
    if (!value) return;

    const start = value.search(/\S/);
    if (start === -1) return;

    const afterStart = value.slice(start);
    const endRel = afterStart.search(/\s/);
    const end = endRel === -1 ? value.length : start + endRel;

    el.setSelectionRange(start, end);
    el.focus();
  }, 0);
};

export const InputHelper = {
  selectFirstWord,
};
